/* App-wide notifications: the shapes returned by `/api/notifications`. */

export type NotificationActor = {
  uid: string;
  name: string;
  avatar_url?: string | null;
};

export type NotificationEntity = { kind: string; id: string };

export type Notification = {
  id: string;
  /** Registry key, e.g. `case_agent.mention`. */
  type: string;
  title: string;
  body: string;
  actor: NotificationActor | null;
  /** In-app path to open, e.g. `/cases/<id>/workspace?thread=…&message=…`. */
  link: string | null;
  entity: NotificationEntity | null;
  /** Free-form; `individual_id` / `thread_id` for the case channel. */
  context: Record<string, unknown>;
  group_key: string | null;
  /** Collapsed repeats (same `group_key` inside the window). */
  count: number;
  channels_sent: Array<"in_app" | "email">;
  read_at: string | null;
  seen_at: string | null;
  created_at: string | null;
  /** Pagination cursor. */
  created_at_ms: number;
};

export type EmailPolicy = "always" | "offline" | "never";

export type TypePreference = { in_app: boolean; email: EmailPolicy };

/** A registered backend type, as listed by the preferences endpoint. */
export type NotificationType = {
  key: string;
  label: string;
  description: string;
  default_in_app: boolean;
  default_email: EmailPolicy;
  /** Preferences section id (one of `groups`). */
  group?: string | null;
  /** Types sharing a row show once and are saved together. */
  preference_row?: string | null;
};

export type NotificationGroup = { id: string; label: string };

export type NotificationPreferences = {
  quiet: boolean;
  /** Effective (defaults merged) per type. */
  per_type: Record<string, TypePreference>;
  types: NotificationType[];
  /** Preferences sections, in order. */
  groups?: NotificationGroup[];
};

export type NotificationsPage = {
  items: Notification[];
  next_cursor: number | null;
  unread_count: number;
  has_unseen: boolean;
};

export const isUnread = (n: Notification): boolean => !n.read_at;
